import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-174f716c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-name", "data-key"]
const _hoisted_2 = { class: "pf_label" }
const _hoisted_3 = { class: "pf_input" }
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id", "name", "value"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "pf_radio_label" }
const _hoisted_8 = { class: "pf_radio_label" }
const _hoisted_9 = { class: "pf_radio_desc" }
const _hoisted_10 = {
  key: 2,
  class: "pf_radio_label"
}
const _hoisted_11 = {
  key: 3,
  class: "pf_radio_label pf_134_only"
}

import { PropType, ref, watch } from 'vue'
    import { Term } from '@/types/product';
    import _ from 'lodash'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductRadio',
  props: {
        id: { type: [String, Number], required: false },
        name: { type: String, required: true },
        label: { type: String, required: true },
        terms: { type: Array as PropType<Term[]>, required: true },
        imageOverrides: { type: Array as PropType<{url: string, attributeEquality: {[key: string]: string}}[]>, required: false },
        modelValue: { type: Object as PropType<Term | null>, required: false } 
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props

    

    const selectedValue = ref<String>('')

    

    watch(selectedValue, (current, old) => {
        if(parseInt(current as string) !== props.modelValue?.id) {
            const activeTerm = props.terms.find(o => o.id === parseInt(current as string))
            emits("update:modelValue", activeTerm)
        }
    })

    watch(() => props.modelValue, (current, old) => {
        if(current?.id !== parseInt(selectedValue.value as string)) {
            selectedValue.value = current?.id.toString() as string
        }
    }, { immediate: true })

    function getTermImageOverride(term: Term) {
        if (props.imageOverrides) {
            for (const imageOverride of props.imageOverrides) {
                // const keys = Object.keys(imageOverride.attributeEquality)
                const termMatches = _.isMatch(term, imageOverride.attributeEquality)
                // keys.reduce((result, key) => {
                //     return result && term[key as keyof(Term)] === imageOverride.attributeEquality[key]
                // }, true)
                if (termMatches) {
                    return imageOverride.url
                }
            }
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pf_container", ['pf_'+props.name]]),
    "data-name": props.name,
    "data-type": "radio",
    "data-key": 'field_' + props.name
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, _toDisplayString(props.label), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", {
        class: _normalizeClass(["pf_radio_list", {'pf_desc_radio': props.terms[0].description}]),
        "data-allow_null": "0",
        "data-other_choice": "0"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.terms, (term) => {
          return (_openBlock(), _createElementBlock("li", {
            key: term.id
          }, [
            _createElementVNode("label", {
              for: 'pf_' + props.name + '-' + term.id,
              class: _normalizeClass({ selected: selectedValue.value == term.id.toString() })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: 'pf_' + props.name + '-' + term.id,
                name: 'pf_' + props.name + ']',
                value: term.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event))
              }, null, 8, _hoisted_5), [
                [_vModelRadio, selectedValue.value]
              ]),
              (term.image)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("img", {
                      src: getTermImageOverride(term) || term.image,
                      class: "pf_radio_img attachment-medium size-medium",
                      alt: term.name,
                      decoding: "async",
                      loading: "lazy"
                    }, null, 8, _hoisted_6),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(term.name), 1)
                  ], 64))
                : (term.description)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(term.name), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(term.description), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(term.name), 1)),
              (term.id == 247 || term.id == 249)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Only for 1-3/4"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4)
          ]))
        }), 128))
      ], 2)
    ])
  ], 10, _hoisted_1))
}
}

})